module.exports = __webpack_public_path__ + "media/public/img/tripadvisor-review-icon-01-1075e2b0a94adb21fd276dbae6e66f68.svg";